import { Chapter } from "./Chapter";
import { Model } from "./Concers/Model";

export class Manual extends Model {
    id: number;
    name: string;
    business_unit_id: number;
    employee_function_id: number;
    is_publishing: boolean;
    created_at: string;
    updated_at: string;
    versions?: any[];
    chapters?: Chapter[];

    public translatable = ["name"];

    constructor(item) {
        super(item);
        this.chapters = item.chapters?.map((chapter) => new Chapter(chapter));
    }
}
